
<template>
    <section id="page-splash">
      <h4 class="adv-logo"><img src="images/logo.png" class="logo-adventify"> ADVENTIFY</h4>
      <div class="adv-caption">Create and play graphic adventures</div>
      <div class="adv-signed-out-only ">
        <div id="firebaseui-auth-container" class="adv-signed-out-only "></div>
        <router-link class="adv-skip" to="/">CANCEL</router-link>
      </div>
    </section>
</template>
<script>
  import App from '../App.vue';
  import firebase from 'firebase';
  import firebaseui from 'firebaseui'

  var sectionSplash;
  var _uiFirebase;

  export default{
    name: 'SectionSplashScreen',
    data: () => ({
      uiFirebase: null,
      uiConfig: {
        'signInSuccessUrl': '/',
        'signInOptions': [
          firebase.auth.GoogleAuthProvider.PROVIDER_ID,
          firebase.auth.FacebookAuthProvider.PROVIDER_ID
        ]
      }
    }),
    mounted() {
      sectionSplash = this;
      var obfuscator = document.querySelector('.mdl-layout__obfuscator.is-visible');
      if(obfuscator) obfuscator.remove();
      if(!_uiFirebase){ 
        _uiFirebase = new firebaseui.auth.AuthUI(window.firebase.auth())
      }
      _uiFirebase.start('#firebaseui-auth-container', this.uiConfig);     
    }
  }
</script>
<style></style>



// WEBPACK FOOTER //
// SectionSplashScreen.vue?c56072a2